import { Box, Divider } from '@mui/material';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { ActiveIndexObject, ISchedule } from 'pages/schedules/interface';

interface DetailItemProps {
  selected?: boolean;
  schedule: ISchedule,
  onClick: (index: number, itemIndex: number) => void;
  index: number;
  itemIndex: number;
}
interface SchedulesListItemProps {
  groupedData: any;
  index: number;
  activeIndexObject: ActiveIndexObject;
  onClick: (index: number, itemIndex: number) => void;
}

const DetailItem = ({
  selected, schedule, onClick, index, itemIndex,
}: DetailItemProps) => {
  const {
    title, sessionType, meta, isCancel,
  } = schedule;

  const startTime = meta?.slot?.from && moment(new Date(meta?.slot?.from)).format('hh:mm A');
  const endTime = meta?.slot?.to && moment(new Date(meta?.slot?.to)).format('hh:mm A');

  const handleClick = () => {
    onClick(index, itemIndex);
  };

  return (
    <Box
      className="col"
      border={1}
      borderRadius={1.5}
      onClick={handleClick}
      sx={{
        backgroundColor: 'grey.A100',
        display: 'flex',
        alignItems: 'center',
        borderColor: selected ? 'primary.main' : 'grey.A100',
        py: 1,
        px: 2,
        mb: 1,
      }}
    >
      { !isCancel ? (
        <>
          <div className="col">
            <Typography variant="body2" sx={{ lineHeight: 1 }}>
              {`${startTime} - ${endTime} - ${title} `}
            </Typography>
          </div>
          <div className="col-auto">
            <Typography variant="subtitle2" sx={{ color: selected ? 'primary.main' : 'text.disabled', lineHeight: 1, textTransform: 'uppercase' }}>
              {sessionType}
            </Typography>
          </div>
        </>
      ) : (
        <>
          <div className="col" color="#999999">
            <span style={{ textDecoration: 'line-through', color: '#999999' }}>
              <Typography variant="body2" sx={{ lineHeight: 1, color: 'text.disabled' }}>
                {`${startTime} - ${endTime} - ${title} `}
              </Typography>
            </span>
          </div>
          <div className="col-auto">
            <Typography variant="subtitle2" sx={{ color: 'text.disabled', lineHeight: 1, textTransform: 'uppercase' }}>
              {sessionType}
            </Typography>
          </div>
        </>
      )}
    </Box>
  );
};

DetailItem.defaultProps = {
  selected: false,
};

const SchedulesListItem = ({
  groupedData, index, activeIndexObject, onClick,
}: SchedulesListItemProps) => {
  const date = moment(groupedData.date, 'YYYY-MM-DD').format('DD');
  const weekDay = moment(groupedData.date, 'YYYY-MM-DD').format('ddd');
  const schedulesOfDay: ISchedule[] = groupedData.events;

  const sortedSchedulesOfDay = schedulesOfDay.sort((a, b) => {
    const startA = moment(a.meta?.slot?.from);
    const startB = moment(b.meta?.slot?.from);
    if (startA.isBefore(startB)) {
      return -1;
    }

    if (startA.isAfter(startB)) {
      return 1;
    }

    return 0;
  });

  return (
    <>
      <div className="row align-items-start">
        <div className="col-12 col-sm-auto mb-3 mb-sm-0 d-flex align-items-center d-flex align-items-center">
          <Box
            className="d-flex align-items-center justify-content-center"
            borderRadius={1.5}
            width={40}
            height={40}
            sx={{
              backgroundColor: 'grey.A100',
            }}
          >
            <Typography variant="h4" sx={{}}>{date}</Typography>
          </Box>
          <Typography variant="subtitle2" sx={{ color: 'text.secondary', lineHeight: 1, mx: 1 }}>{weekDay}</Typography>
        </div>
        <div className="col d-flex flex-column pt-1">
          {sortedSchedulesOfDay.map((schedule: ISchedule, itemIndex: number) => (
            <DetailItem
              key={`${Math.random()}-${schedule.id}`}
              onClick={onClick}
              selected={
                (activeIndexObject.parentIndex === index)
                && (activeIndexObject.itemIndex === itemIndex)
              }
              schedule={schedule}
              index={index}
              itemIndex={itemIndex}
            />
          ))}
        </div>
      </div>
      <Divider sx={{ mt: 1.75, mb: 2.5 }} />
    </>
  );
};

export default SchedulesListItem;
